import { render, staticRenderFns } from "./OrderShipments.vue?vue&type=template&id=8ebeec4c&scoped=true"
import script from "./OrderShipments.vue?vue&type=script&lang=js"
export * from "./OrderShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebeec4c",
  null
  
)

export default component.exports